<script>
import {useMenuStore} from "@js/store/MenuStore.js";
import {useCartStore} from "@js/store/CartStore.js";
import {useThemeStore} from "@js/store/ThemeStore.js";
import {checkDocument, getCookie, setCookie} from "@js/helpers.ts";
import {useJivoStore} from "@js/store/JivoStore.js";
import {contacts} from "@js/company_details.ts";
import {Link, usePage} from "@inertiajs/vue3";
import IconPhone from "@js/components/Icons/IconPhone.vue";
import IconWhatsApp from "@js/components/Icons/IconWhatsApp.vue";
import IconMobileMenu from "@js/components/Icons/IconMobileMenu.vue";
import IconChatFilled from "../Icons/IconChatFilled.vue";
import IconArrowRight from "../Icons/IconArrowRight.vue";
import IconTelegram from "../Icons/IconTelegram.vue";
import IconHomeFilled from "@js/components/Icons/IconHomeFilled.vue";
import IconCartFilled from "@js/components/Icons/IconCartFilled.vue";
import IconUserCircleFilled from "@js/components/Icons/IconUserCircleFilled.vue";
import IconBurger from "@js/components/Icons/IconBurger.vue";
import IconGrid from "@js/components/Icons/IconGrid.vue";
import IconAngleLeft from "@js/components/Icons/IconAngleLeft.vue";
import IconX from "@js/components/Icons/IconX.vue";

export default {
    name: "MobileNav",
    components: {
        IconX,
        IconAngleLeft,
        IconGrid,
        IconBurger,
        IconUserCircleFilled,
        IconCartFilled,
        IconHomeFilled,
        IconTelegram,
        IconArrowRight,
        IconChatFilled,
        IconMobileMenu,
        IconWhatsApp,
        IconPhone,
        Link,
    },
    data() {
        return {
            show_banner: false,
            speed_dial_show: false,
            touchStartX: 0,
            touchStartY: 0,
            touchEndX: 0,
            touchEndY: 0,
            scrollListener: null,
        }
    },
    methods: {
        closeBanner() {
            setCookie('banner_closed', '1', 525600) // на год
            this.show_banner = false
        },
        checkBanner() {
            return getCookie('banner_closed') === '1'
        },
        toggleDial() {
            this.show_banner = false
            this.speed_dial_show = !this.speed_dial_show;
        },
        hideDial() {
            this.speed_dial_show = false
        },
        handleClickOutside(event) {
            const dropdown = this.$refs.speedDialRef;
            const button = this.$refs.speedDialButtonRef;

            if (
                dropdown &&
                !dropdown.contains(event.target) &&
                button &&
                !button.contains(event.target)
            ) {
                this.speed_dial_show = false
            }
        },
        onTouchStart(e) {
            this.touchStartX = e.touches[0].clientX;
            this.touchStartY = e.touches[0].clientY;
        },
        onTouchMove(e) {
            this.touchEndX = e.touches[0].clientX;
            this.touchEndY = e.touches[0].clientY;
        },
        onTouchEnd() {
            const deltaX = this.touchEndX - this.touchStartX;
            const deltaY = Math.abs(this.touchEndY - this.touchStartY);
            const threshold = 50; // минимальная дистанция свайпа

            // если горизонтальный свайп вправо длиннее threshold и вертикальная составляющая мала
            if (deltaX > threshold && deltaY < 50 && this.speed_dial_show) {
                this.speed_dial_show = false;
            }
        },
        onScroll() {
            if (this.speed_dial_show) {
                this.speed_dial_show = false;
            }
        },
        openJivoChat() {
            this.jivoStore.openJivoChat()
            this.hideDial()
        },
    },
    setup() {
        const menuStore = useMenuStore()
        const cartStore = useCartStore()
        const themeStore = useThemeStore()
        const jivoStore = useJivoStore()

        return {menuStore, cartStore, themeStore, jivoStore, contacts}
    },
    mounted() {
        if (!checkDocument()) {
            document.addEventListener("click", this.handleClickOutside);
            this.scrollListener = this.onScroll.bind(this);
            window.addEventListener("scroll", this.scrollListener, {passive: true});

            if (!this.checkBanner()) {
                this.show_banner = true
            }
        }
    },
    beforeUnmount() {
        if (!checkDocument()) {
            document.removeEventListener("click", this.handleClickOutside);
            window.removeEventListener("scroll", this.scrollListener);
        }
    },
    computed: {
        highlightHome() {
            const homePath = route('home', {}, false)
            return this.$page.url !== homePath && !this.highlightChat
        },
        highlightChat() {
            const path = this.$page.url
            return path.startsWith('/collection') || path.startsWith('/product')
        },
    }
};
</script>

<template>
    <div ref="speedDialRef"
         @touchstart.passive="onTouchStart"
         @touchmove.passive="onTouchMove"
         @touchend="onTouchEnd"
         class="fixed z-10 bottom-[80px] max-w-[90%] left-0 m-auto transition-all duration-300 ease-in-out"
         :class="speed_dial_show ? 'right-0' : '-right-[200%]'">
        <div class="flex items-center justify-end gap-5">
            <div @click.prevent="hideDial"
                 class="flex justify-center items-center min-w-[52px] max-w-[52px] min-h-[52px] max-w-[52px] text-white bg-gray-600/90 rounded-full border border-gray-600 shadow focus:ring-0 focus:outline-none">
                <IconArrowRight class="w-6 h-6"/>
            </div>
            <a :href="contacts.whatsapp" target="_blank" @click="hideDial"
               class="flex justify-center items-center min-w-[52px] max-w-[52px] min-h-[52px] max-w-[52px] text-gray-500 bg-white rounded-full border border-gray-500 shadow focus:ring-0 focus:outline-none">
                <IconWhatsApp class="w-6 h-6 text-whatsapp"/>
            </a>
            <a :href="contacts.telegram" target="_blank" @click="hideDial"
               class="flex justify-center items-center min-w-[52px] max-w-[52px] min-h-[52px] max-w-[52px] text-gray-500 bg-white rounded-full border border-gray-500 shadow focus:ring-0 focus:outline-none">
                <IconTelegram class="w-5 h-5 text-telegram -ms-0.5"/>
            </a>
            <div @click.prevent="openJivoChat"
                 class="flex justify-center items-center min-w-[52px] max-w-[52px] min-h-[52px] max-w-[52px] text-gray-500 bg-white rounded-full border border-gray-500 shadow focus:ring-0 focus:outline-none">
                <div class="relative">
                    <IconChatFilled class="w-6 h-6 text-gray-700"/>
                    <span v-if="jivoStore.hasUnreadMessages"
                          class="absolute -top-0.5 -right-0.5 w-2 h-2 bg-red-600 rounded-full"></span>
                </div>
            </div>
            <a :href="'tel:+' + contacts.first_phone" @click="hideDial"
               class="flex justify-center items-center min-w-[52px] max-w-[52px] min-h-[52px] max-w-[52px] text-gray-500 bg-white rounded-full border border-gray-500 shadow focus:ring-0 focus:outline-none">
                <IconPhone class="w-7 h-7 text-gray-700"/>
            </a>
        </div>
    </div>
    <div
        class="fixed bottom-0 left-0 z-10 w-full rounded-t-2xl bg-white border-t border-gray-300 shadow-sm">
        <div v-if="show_banner" class="max-w-lg px-2 my-2 mx-auto">
            <a :href="contacts.telegram" @click="closeBanner" target="_blank"
               class="flex items-center justify-between gap-3 rounded-lg bg-grayBg ps-2 pe-3">
                <div class="flex items-center gap-3">
                    <div class="bg-telegram rounded-lg p-2.5 my-2">
                        <IconTelegram class="w-4 h-4 text-white"/>
                    </div>
                    <p class="text-[13px] leading-tight font-medium">
                        Подпишитесь на Telegram,<br/> получите скидку 20%
                    </p>
                </div>
                <div class="flex items-center gap-3">
                    <a :href="contacts.telegram" class="bg-baseColor rounded-lg p-2.5 my-2">
                        <IconAngleLeft class="w-4 h-4 text-black rotate-180"/>
                    </a>
                    <div @click.prevent="closeBanner" class="border-s border-black h-[20px] ps-2">
                        <IconX class="w-5 h-5"/>
                    </div>
                </div>
            </a>
        </div>
        <div class="grid h-full max-w-lg grid-cols-5 mx-auto text-gray-500 my-2">
            <Link :href="route('home')" aria-label="Главная" title="Главная"
                  class="inline-flex flex-col items-center justify-center font-medium px-5 group">
                <IconHomeFilled class="w-7 h-7 mb-1"
                                :class="{'text-baseColor': highlightHome}"/>
                <span class="text-xs font-bold">
                    Главная
                </span>
            </Link>
            <div ref="speedDialButtonRef" @click.prevent="toggleDial"
                 class="inline-flex flex-col items-center justify-center font-medium px-5 group">
                <IconChatFilled class="w-7 h-7 mb-0.5"
                                :class="{'text-baseColor': highlightChat}"/>
                <span class="text-xs font-bold">
                    Связь
                </span>
            </div>
            <div @click.prevent="menuStore.toggleSidenav"
                 class="inline-flex flex-col items-center justify-center font-medium px-5 group">
                <IconGrid class="w-8 h-8 mb-0.5 text-baseColor stroke-gray-300"/>
                <span class="text-xs font-bold">
                    Каталог
                </span>
            </div>
            <Link :href="route('cart')"
                  class="inline-flex flex-col items-center justify-center font-medium px-5 group">
                <IconCartFilled class="w-7 h-7 mb-0.5"/>
                <span class="text-xs font-bold">
                    Корзина
                </span>
            </Link>
            <div @click.prevent="menuStore.toggleProfileSidenav"
                 class="inline-flex flex-col items-center justify-center font-medium px-5 group">
                <IconBurger class="w-7 h-7 mb-0.5"/>
                <span class="text-xs font-bold">
                    Меню
                </span>
            </div>
        </div>
    </div>
</template>

<style scoped lang="scss">

</style>
